module.exports = __webpack_public_path__ + "img/cancel.0496b948.svg";